import React from 'react';

interface ModalContextType {
  openModal: () => void;
  closeModal: () => void;
}

export const ModalContext = React.createContext<ModalContextType | undefined>(undefined);